import React from 'react';
import Container from 'react-bootstrap/Container';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import PdfDocument from '../generateInvoice/Invoice';
import InvoiceData from '../generateInvoice/jsonData/InvoiceData';
import '../../App.css';

const InvoicesPage = (props) => {

  const t = props.t;
  const fileName = "Invoice.pdf";

  return (
    <div className="App">
      <PDFViewer width={800} height={800} showToolbar={false}>
        <PdfDocument invoicedata={InvoiceData}  t={t} />
      </PDFViewer>

      <div className='download-link'>
        <PDFDownloadLink
          document={<PdfDocument invoicedata={InvoiceData} t={t} />}
          fileName={fileName}
        >
          {({ blob, url, loading, error }) =>
            loading ? "Loading..." : "Download Invoice"
          }
        </PDFDownloadLink>
      </div>
    </div>

  );
};

export default InvoicesPage;